/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-regex-literals */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef } from 'react';
import { Grid, TextField } from '@material-ui/core';
import SearchSelect from 'react-select';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Typography } from '@mui/material';
import validator from 'validator';
import LazyMenuList from './components/LazyMenuList';
import AntSwitch from '../dailydose/AntSwitch';
import Theme from '../ui/Theme';
import Modal from '../common/Modal';
import {
  getDepartmentRoleList,
  getAllDepartments,
  // getEmployeeList,
  showProgress,
  getDealershipList,
  getChildrenDealerships,
  // getDealershipMenu,
  // getRoleList,
} from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import EnableReportingMultiDropDown from './EnableReportingMultiDropDown';
import MultiSelectSearch from '../common/search/MultiSelectSearch';
import { apiEndpoints } from '../../constants/apiEndpoints';
import ExternalProfilesCard from './ExternalProfilesCard';
import CustomPopupText from '../shared/CustomPopupText';
import CustomTextField from '../shared/CustomTextField';
import CustomDropDown from '../shared/CustomDropDown';
import CustomButton from '../shared/CustomButton';
import HighestStreak from './components/HighestStreak';
import useFetchDetails from './hooks/useFetchDetails';
import ConfirmationDialog from '../common/ConfirmationDialog';
import AccessIcon from '../../assets/AccessIcon';

toast.configure();
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    maxHeight: '58vh',
    overflowY: 'scroll',
  },
  deptField: {
    border: 0,
    outline: 0,
    backgroundColor: Theme.palette.secondary.main,
    height: '32px',
    width: '396px',
    fontSize: '12px',
    color: '#000000',
  },
  requiredField: {
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  listTextSelected: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '17px',
    fontStyle: 'normal',
  },
  listTextNonSelected: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '17px',
    fontStyle: 'normal',
  },
  listSubTextSelected: {
    color: Theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    marginTop: '5px',
  },
  listSubTextNonSelected: {
    color: 'rgba(0, 0, 0, 0.4)',
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    marginTop: '5px',
  },
  highlightItem: {
    borderRight: `4px solid ${Theme.palette.primary.main}`,
  },
  nonHighlightItem: {},

  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
    paddingLeft: '18px',
  },
  popupSubHeading: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginTop: 0,

    paddingLeft: '18px',
  },
  popupInputContainer: {
    textAlign: 'left',
    padding: '18px',
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  popInputs: {
    border: 0,
    outline: 0,
    backgroundColor: Theme.palette.secondary.main,
    height: '45px',
    width: '375px',
    padding: '0 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
  },
  popupBtnContainer: {
    marginTop: '4px',
    padding: '10px',
    position: 'sticky',
    bottom: '-28px',
    background: '#fff',
  },
  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    width: '170px',
  },
  popCancelBtn: {
    padding: '0 70px',
    marginRight: '28px',
    height: '45px',
    width: '170px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  metaDataField: {
    backgroundColor: Theme.palette.secondary.main,
    height: '100px',
    width: '375px',
    padding: '5px 10px',
    marginLeft: '0px',
    marginTop: '10px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '17px',
    marginBottom: '9px',
  },
  formControl: {
    margin: theme.spacing(1),
    marginLeft: '0px',
    padding: '8px',
    width: '100%',
    outline: 0,
    border: 0,
    backgroundColor: Theme.palette.secondary.main,
  },
  switchLabelStyle: {
    marginBottom: '10px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  switchStyle: {
    width: '100%',
    marginTop: '10px',
    marginBottom: '20px',
  },
  selectRole: {
    marginTop: theme.spacing(2),
    '&:hover': {
      border: `0px solid ${Theme.palette.secondary.main}`,
    },
  },
  dealershipChangeField: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    marginTop: '10px',
    marginBottom: '10px',
  },
  ellipsisMessage: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '300px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  itemTitle: {
    fontFamily: 'Lato !important',
    fontWeight: '700 !important',
    fontSize: '16px !important',
    lineHeight: '140% !important',
  },
  itemContainer: {
    border: '2px solid #F5F5F5',
    borderRadius: '8px',
    margin: '10px 0px 10px 20px',
  },
}));

const AddnewDepartmentPopup = (props) => {
  const classes = useStyles();
  const { fetchChildrenList } = useFetchDetails();
  const [viewDealershipPop, setViewDealershipPop] = useState(props.open);
  const [rolesList, setRolesList] = useState([]);
  const isAdd = props.add;

  const customDepartment = useSelector((state) => state.getCustomDepartment.customDepartment);
  const dealershipID = useSelector((state) => state.getDealershipID);
  const departmentID = useSelector((state) => state.getDepartment);
  const roleIDRedux = useSelector((state) => state.getSelectedRoleID);
  const dealershipList = useSelector((state) => state.GetDealershipList.dealershiplist);
  const dealershipListDropDown = useSelector((state) => state.GetDealershipList.dealershiplist)?.map((i) => ({
    value: i.id,
    label: i.name,
  }));
  const dealershipChildren = useSelector((state) => state.getChildrenDealerships?.dealershipChildren);
  const dealershipCustomGroups = useSelector(
    (state) => state.getCustomGroupsForDealership?.dealershipCustomGroups,
  )?.map((d) => ({ label: d.name, value: d.id }));
  const [enableReportingChildren, setEnableReportingChildren] = useState([]);

  const deptList = [
    ...(useSelector((state) => state.getAllDepartments.departments) || []),
    ...(dealershipCustomGroups?.length && customDepartment?.id
      ? [{ id: customDepartment.id, title: customDepartment.title }]
      : []),
  ];
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState();
  const [enabledVal, setEnabled] = useState(1);
  const [multiDept, setMultiDeptEnabled] = useState(0);
  const [lastName, setLastName] = useState();
  const [primaryContactEmail, setPrimaryContactEmail] = useState();
  const [secondaryContactEmail, setSecondaryContactEmail] = useState('');
  const [metaData, setMetaData] = useState({});
  const [externalProfiles, setExternalProfiles] = useState([]);
  const [externalEmail, setExternalEmail] = useState('');
  const [enableAssign, setEnableAssign] = useState(false);
  const [roleID, setRoleID] = useState(1);
  const [prevRoleID, setPrevRoleID] = useState(1);
  const [employeeDealership, setEmployeeDealership] = useState();
  const [deptID, setDeptID] = useState(0);
  const [prevDeptID, setPrevDeptID] = useState(0);
  const [selectedCustomGroups, setSelectedCustomGroups] = useState([]);
  const [streak, setStreak] = useState({ currentStreak: 0, highestStreak: 0 });
  const [isInstructor, setIsInstructor] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const insightsAccessFlagRef = useRef(false);

  React.useEffect(() => {
    getAllDepartment(departmentID === 0);
    fetchChildrenList(dealershipID);
    if (props.hash !== undefined) {
      dispatch(showProgress(true));
      getEmp();
    }
  }, []);

  React.useEffect(() => {
    if (departmentID) {
      setDeptID(departmentID);
      getRoles(departmentID, 0);
    }
  }, [departmentID]);

  const getEmp = async () => {
    const newId = props.hash;
    await service
      .get(apiEndpoints.DEALER_GET_BY_ID.replace('ID', newId), '')
      .then(async (response) => {
        // when we edit employee from rules tab dealership id = 1
        // so children list is not updated
        if (dealershipID !== response.dealershipId || props.flow === 'rules') {
          try {
            const dealershipChildrenResponse = await service.get(
              apiEndpoints.DEALER_CHILDREN_LIST.replace('DEALER_ID', response.dealershipId),
              '',
            );
            dispatch(getChildrenDealerships(dealershipChildrenResponse));
          } catch (err) {
            console.log(err);
          }
        }
        insightsAccessFlagRef.current = response.insightsAccessFlag;
        setEmployeeDealership(dealershipListDropDown?.filter((i) => i.value === response.dealershipId)[0]);
        setSelectedCustomGroups(response.customGroups?.map((d) => ({ label: d.name, value: d.id })) || []);
        setDeptID(response.departmentId);
        setPrevDeptID(response.departmentId);
        setRoleID(response.roleId);
        setPrevRoleID(response.roleId);
        setFirstName(response.firstName);
        setLastName(response.lastName);
        setExternalProfiles(response.externalProfiles);
        setStreak({ currentStreak: response?.currentStreak, highestStreak: response?.highestStreak });
        // setDeptName(response.reportEmployeeDepartments.map((item) => item.title));
        // setDeptIds(response.reportEmployeeDepartments.map((item) => item.id));
        setEnableReportingChildren(response.reportEmployeeDepartments || []);
        if (response.reportEmployeeDepartments?.length > 0) {
          setMultiDeptEnabled(1);
        } else {
          setMultiDeptEnabled(0);
        }
        setPrimaryContactEmail(response.primaryContactEmail);
        setSecondaryContactEmail(response.secondaryContactEmail ? response.secondaryContactEmail : '');
        setEnableAssign(response.enableAssign);
        setEnabled(response.enabled);
        setMetaData(response.metaData);
        setIsInstructor(response.isInstructor || false);
        dispatch(showProgress(false));
        getRoles(response.departmentId, 0);
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  const notifyEditError = (msg) => {
    toast.error(
      <>
        {msg.map((x) => (
          <div> {x}</div>
        ))}
      </>,
      {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
      },
    );
  };
  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (!firstName?.trim()) {
      formIsValid = false;
      errors.push('Please enter your First Name.');
    }
    if (!lastName?.trim()) {
      formIsValid = false;
      errors.push('Please enter your Last Name.');
    }
    if (!primaryContactEmail) {
      formIsValid = false;
      errors.push('Please enter your email-ID.');
    }
    if (multiDept) {
      if (!enableReportingChildren?.length) {
        formIsValid = false;
        errors.push('Please add the reporting departments ');
      }
    }
    if (!isAdd && !employeeDealership && !employeeDealership?.value) {
      formIsValid = false;
      errors.push('Employee Dealership cannot be empty');
    }
    if (!selectedCustomGroups.length && parseInt(deptID, 10) === customDepartment.id) {
      formIsValid = false;
      errors.push('Either select a custom group or select a department');
    }
    if (typeof primaryContactEmail !== 'undefined' && primaryContactEmail) {
      if (!validator.isEmail(primaryContactEmail)) {
        formIsValid = false;
        errors.push('Please enter valid email-ID.');
      }
    }
    if (typeof secondaryContactEmail !== 'undefined' && secondaryContactEmail) {
      if (!validator.isEmail(secondaryContactEmail)) {
        formIsValid = false;
        errors.push('Please enter valid secondary email-ID.');
      }
    }

    if (errors.length !== 0) {
      notifyEditError(errors);
    }
    return formIsValid;
  };
  const closePopup = () => {
    setViewDealershipPop(false);
    props.close();
  };
  const handleChangeRole = (event) => {
    setRoleID(event.target.value);
  };

  const handleChangeDealership = (dropDownValue) => {
    setEmployeeDealership(dropDownValue);
  };

  const handleChangeDept = (event) => {
    setDeptID(event.target.value);
    getRoles(event.target.value, 1);
  };
  const getRoles = async (id, flag) => {
    dispatch(showProgress(true));
    if (id !== customDepartment.id) {
      await service
        .get(apiEndpoints.DEALER_ROLES.replace('ID', id), '')
        .then((res) => {
          res.sort((a, b) => a.id - b.id);
          setRolesList([...res]);
          if (flag === 0 && roleIDRedux !== 0) {
            setRoleID(roleIDRedux);
          } else if (isAdd || (deptID !== id && deptID !== 0)) {
            setRoleID(res[0]?.id);
          }

          dispatch(getDepartmentRoleList(res));
          dispatch(showProgress(false));
        })
        .catch(() => {
          dispatch(showProgress(false));
        });
    } else {
      setRolesList(customDepartment.departmentRoles);
      setRoleID(customDepartment.departmentRoles[0].id);
      dispatch(getDepartmentRoleList(customDepartment.departmentRoles));
      dispatch(showProgress(false));
    }
  };
  const getAllDepartment = async (setState = true) => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.GET_DEPARTMENTS, '')
      .then((res) => {
        dispatch(getAllDepartments(res));
        if (props.hash === undefined && setState) {
          getRoles(res[0].id, 0);
          setDeptID(res[0].id);
        }
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  const setEnableFlag = (e) => {
    if (e.target.checked === true) {
      setEnabled(1);
    } else {
      setEnabled(0);
    }
  };
  const setAssignEnableFlag = (e) => {
    setEnableAssign(e.target.checked);
  };
  const setInstructorFlag = (e) => {
    setIsInstructor(e.target.checked);
  };
  const setMultiDeptFlag = (e) => {
    if (e.target.checked === true) {
      setMultiDeptEnabled(1);
    } else {
      setMultiDeptEnabled(0);
      setEnableReportingChildren([]);
    }
  };
  const onClickAddNewDealer = (removeAccess = false) => {
    setShowConfirmationDialog(false);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const enableEmployee = async (res) => {
      const enableData = new FormData();
      enableData.append('enable', enabledVal === 1);
      await service
        .put(apiEndpoints.DEALER_EMPLOYEE_UPDATE.replace('HASH', res.hash), enableData)
        .then(() => {
          res.enabled = enabledVal === 1;
          closePopup();
          notifySuccess('Saved Successfully');
          dispatch(showProgress(false));
        })
        .catch((error) => {
          console.log(error);
          dispatch(showProgress(false));
        });
    };
    const updateEnableStatusEmployee = async (res) => {
      const enableData = new FormData();
      enableData.append('enable', enabledVal);
      await service
        .put(apiEndpoints.DEALER_EMPLOYEE_UPDATE.replace('HASH', props.hash), enableData)
        .then(() => {
          res.enabled = enabledVal;
          notifySuccess('Saved Successfully');
          closePopup();
          dispatch(showProgress(false));
        })
        .catch((error) => {
          console.log(error);
          dispatch(showProgress(false));
        });
    };
    const addNewEmployee = async () => {
      const data = new FormData();
      data.append('dealershipId', dealershipID);
      data.append('departmentRoleId', roleID);
      data.append('firstName', firstName?.trim() || '');
      data.append('lastName', lastName?.trim() || '');
      data.append('primaryContactEmail', primaryContactEmail);
      if (secondaryContactEmail !== '') {
        data.append('secondaryContactEmail', secondaryContactEmail);
      }
      data.append('enableAssign', enableAssign);

      if (Array.isArray(enableReportingChildren)) {
        for (const val of enableReportingChildren) {
          if (val !== undefined) {
            data.append('reportDepartmentDealershipIds', val);
          }
        }
      }
      selectedCustomGroups
        ?.map((cGId) => cGId.value)
        .filter((d) => d !== '*')
        .map((i) => data.append('customGroupIds', i));
      const check = validateForm();
      if (check) {
        dispatch(showProgress(true));
        await service
          .post(apiEndpoints.DEALER_EMPLOYEE_CREATE, data)
          .then((res) => {
            enableEmployee(res);
            const empTargetCount = dealershipList.filter((item) => item.id === dealershipID)[0].employeesCount || 0;
            const updateTargetDealerData = { id: dealershipID, count: empTargetCount + 1 };
            dispatch(getDealershipList('count', updateTargetDealerData));
          })
          .catch((error) => {
            ErrorToast(error);
            dispatch(showProgress(false));
          });
      }
    };
    const EditEmployee = async () => {
      const check = validateForm();
      if (check) {
        const data = new FormData();
        data.append('dealershipId', employeeDealership.value);
        data.append('departmentRoleId', roleID);
        data.append('firstName', firstName?.trim() || '');
        data.append('lastName', lastName?.trim() || '');
        if (externalEmail) {
          data.append('externalProfileUpdates', JSON.stringify(externalEmail));
        }
        if (primaryContactEmail !== '') {
          data.append('primaryContactEmail', primaryContactEmail);
        }
        if (secondaryContactEmail !== '') {
          data.append('secondaryContactEmail', secondaryContactEmail);
        }
        data.append('enableAssign', enableAssign);
        data.append('isInstructor', isInstructor);
        data.append('removeAccess', removeAccess);

        if (Array.isArray(enableReportingChildren)) {
          for (const val of enableReportingChildren) {
            if (val !== undefined) {
              data.append('reportDepartmentDealershipIds', val);
            }
          }
        }
        selectedCustomGroups
          ?.map((cGId) => cGId.value)
          .filter((d) => d !== '*')
          .map((i) => data.append('customGroupIds', i));
        dispatch(showProgress(true));
        await service
          .put(apiEndpoints.DEALER_GET_BY_ID.replace('ID', props.hash), data)
          .then((res) => {
            res.key = props.hash;
            const roleChanged = prevRoleID !== parseInt(roleID, 10);
            const departmentChanged = prevDeptID !== parseInt(deptID, 10);
            const dealershipChanged = employeeDealership.value !== dealershipID;

            if (roleChanged) {
              // dispatch(getRoleList('DEC', prevRoleID));
              // if (!dealershipChanged) dispatch(getRoleList('INC', parseInt(roleID, 10)));
            }
            if (departmentChanged) {
              // dispatch(getDealershipMenu('dec_emp_count', { id: prevDeptID }));
              // if (!dealershipChanged) dispatch(getDealershipMenu('inc_emp_count', { id: parseInt(deptID, 10) }));
            }
            if (dealershipChanged) {
              // dispatch(getDealershipMenu('dec_emp_count', { id: 0 }));

              // if (!roleChanged) dispatch(getRoleList('DEC', prevRoleID));
              // if (!departmentChanged) dispatch(getDealershipMenu('dec_emp_count', { id: prevDeptID }));

              // Current dealership DEC employee count
              const empCurrentCount = dealershipList.filter((item) => item.id === dealershipID)[0].employeesCount || 0;
              const updateCurrentDealerData = { id: dealershipID, count: empCurrentCount - 1 };
              dispatch(getDealershipList('count', updateCurrentDealerData));

              // Target dealership INC employee count
              const empTargetCount =
                dealershipList.filter((item) => item.id === employeeDealership.value)[0].employeesCount || 0;
              const updateTargetDealerData = { id: employeeDealership.value, count: empTargetCount + 1 };
              dispatch(getDealershipList('count', updateTargetDealerData));
            }
            updateEnableStatusEmployee(res);
          })
          .catch((error) => {
            console.log(error);
            const err = [];
            if (error.message === 'Domain is not supported') {
              err.push('Domain is not supported');
            } else if (error.message) {
              err.push(error.message);
            }
            notifyEditError(err);
            dispatch(showProgress(false));
          });
      }
    };

    if (isAdd) {
      addNewEmployee();
    } else {
      EditEmployee();
    }
  };

  const showConfirmationPopup = () => dealershipID !== employeeDealership.value && insightsAccessFlagRef.current;

  const handleSave = () => {
    if (!isAdd && showConfirmationPopup()) {
      setShowConfirmationDialog(true);
    } else {
      onClickAddNewDealer();
    }
  };

  const handleChangeEnableReporting = (childDealershipReports) => {
    setEnableReportingChildren(childDealershipReports);
  };
  const handleExternalEmailChange = ({ target: { id, name, value, checked } }) => {
    if (name === 'externalEmail') {
      setExternalEmail((prev) => ({ ...prev, [id]: { email: value, enabled: prev[id]?.enabled } }));
    } else {
      setExternalEmail((prev) => ({ ...prev, [id]: { email: prev[id]?.email, enabled: checked } }));
    }
  };

  const formatOptionLabel = ({ label, value }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div className={classes.ellipsisMessage}>{label}</div>
      {employeeDealership.value !== value ? <div>{value}</div> : null}
    </div>
  );

  const handleDropdownChange = (value) => {
    setSelectedCustomGroups(value);
    if (customDepartment.id !== deptID && isAdd) {
      setDeptID(customDepartment.id);
      getRoles(customDepartment.id, 1);
    }
  };

  const formatUserName = (name) =>
    name
      .trimStart()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  return (
    <Modal isOpen={viewDealershipPop} height="80vh" width="860px" padding="26px">
      <Grid container spacing={1}>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={11}>
            <p className={classes.popupHeading}>{isAdd ? 'Adding New' : 'Edit'} Employee</p>
          </Grid>
          <Grid item xs={1}>
            <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
          </Grid>
        </Grid>
        <Grid item style={{ marginLeft: '15px' }}>
          <Typography className={classes.itemTitle}>Employee Streak</Typography>
        </Grid>
        <Grid container direction="column" className={classes.itemContainer}>
          <Grid item xs={12}>
            <HighestStreak
              hash={props.hash}
              current={streak.currentStreak}
              highest={streak.highestStreak}
              getEmp={getEmp}
            />
          </Grid>
        </Grid>
        <Grid item style={{ marginLeft: '15px' }}>
          <Typography className={classes.itemTitle}>Internal Profile</Typography>
        </Grid>

        <Grid container direction="row" className={classes.itemContainer}>
          <Grid item xs={6} className={classes.popupInputContainer}>
            <CustomPopupText text="First Name" required />
            <CustomTextField
              name="title"
              value={firstName}
              width="100%"
              handleChange={(e) => setFirstName(formatUserName(e.target.value))}
            />
            <CustomPopupText text="Last Name" required />
            <CustomTextField
              name="title"
              value={lastName}
              width="100%"
              handleChange={(e) => setLastName(formatUserName(e.target.value))}
            />
            <CustomPopupText text="Department" required />
            <CustomDropDown
              width="100%"
              value={deptList?.find((dept) => dept?.id === deptID)?.title || 'Select a value'}
              name="expertiseLevel"
              list={deptList}
              handleChange={handleChangeDept}
            />

            {dealershipCustomGroups?.length ? (
              <>
                <Grid item style={{ marginBottom: '10px' }}>
                  <CustomPopupText text="Custom Groups" />
                </Grid>
                <Grid item style={{ marginBottom: '10px' }}>
                  <MultiSelectSearch
                    placeholderButtonLabel="Select Custom Groups"
                    selectedOptions={selectedCustomGroups}
                    onChange={handleDropdownChange}
                    options={dealershipCustomGroups}
                    name="custom_groups"
                    width="396px"
                    showValue
                  />
                </Grid>
              </>
            ) : null}
            <Grid
              component="label"
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              className={classes.switchStyle}
            >
              <Grid item>
                <CustomPopupText text="Enable Reporting" />
              </Grid>
              <Grid item>
                <AntSwitch
                  checked={multiDept}
                  onChange={setMultiDeptFlag}
                  inputProps={{ 'aria-label': 'ant design' }}
                />
              </Grid>
            </Grid>
            {multiDept ? (
              <EnableReportingMultiDropDown
                dealershipChildren={dealershipChildren}
                deptList={deptList}
                handleChangeEnableReporting={handleChangeEnableReporting}
                enableReportingChildren={enableReportingChildren}
                height="43px"
                marginBottom="10px"
                name="enable-reporting"
              />
            ) : null}
            <Grid
              component="label"
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              className={classes.switchStyle}
            >
              <Grid item>
                <CustomPopupText text="Enable Assignment" />
              </Grid>
              <Grid item>
                <AntSwitch
                  checked={enableAssign}
                  onChange={setAssignEnableFlag}
                  inputProps={{ 'aria-label': 'ant design' }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} className={classes.popupInputContainer}>
            <CustomPopupText text="Primary Contact Email" required />
            <CustomTextField
              name="title"
              value={primaryContactEmail}
              width="100%"
              handleChange={(e) => setPrimaryContactEmail(e.target.value)}
            />
            <CustomPopupText text="Secondary Contact Email" />
            <CustomTextField
              name="title"
              value={secondaryContactEmail}
              width="100%"
              handleChange={(e) => setSecondaryContactEmail(e.target.value)}
            />
            <CustomPopupText text="Role" required />
            <CustomDropDown
              width="100%"
              value={rolesList?.find((dept) => dept?.id === roleID)?.title || 'Select a value'}
              name="expertiseLevel"
              list={rolesList}
              handleChange={handleChangeRole}
            />

            {!isAdd ? (
              <>
                <CustomPopupText text="Dealership" required />
                <SearchSelect
                  placeholder="Select Employee Dealership"
                  value={employeeDealership}
                  onChange={handleChangeDealership}
                  options={dealershipListDropDown}
                  formatOptionLabel={formatOptionLabel}
                  maxMenuHeight="200px"
                  className={classes.dealershipChangeField}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: '#f4f4f4',
                    }),
                  }}
                  components={{ MenuList: LazyMenuList }}
                />
              </>
            ) : null}
            {Object.keys(metaData).length !== 0 && (
              <div>
                <div className={classes.popupLabels}>
                  <label htmlFor="dealership">Metadata</label>
                </div>
                <TextField
                  id="previewVideoLinkId"
                  name="previewVideoLink"
                  required
                  autoFocus
                  autoComplete="off"
                  autoSave="off"
                  disabled
                  placeholder="No Metadata available"
                  multiline
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: classes.metaDataField,
                    },
                  }}
                  value={JSON.stringify(metaData)}
                  rows={5}
                />
              </div>
            )}
            <Grid
              component="label"
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              className={classes.switchStyle}
            >
              <Grid item>
                <CustomPopupText text="Enable/Disable Employee" />
              </Grid>
              <Grid item>
                <AntSwitch checked={enabledVal} onChange={setEnableFlag} inputProps={{ 'aria-label': 'ant design' }} />
              </Grid>
            </Grid>
            <Grid
              component="label"
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              className={classes.switchStyle}
            >
              {!isAdd && (
                <>
                  <Grid item>
                    <CustomPopupText text="Allow user to facilitate courses" />
                  </Grid>
                  <Grid item>
                    <AntSwitch
                      checked={isInstructor}
                      onChange={setInstructorFlag}
                      inputProps={{ 'aria-label': 'ant design' }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>

        {externalProfiles.length ? (
          <Grid container>
            <Grid item style={{ margin: '15px' }}>
              <Typography className={classes.itemTitle}>External Profile</Typography>
            </Grid>
            <Grid item xs={12} style={{ marginLeft: '15px' }}>
              <Grid container direction="row" spacing={2}>
                {externalProfiles?.map((profile) => (
                  <Grid item xs={12}>
                    <ExternalProfilesCard data={profile} handleExternalEmailChange={handleExternalEmailChange} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        ) : null}
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={1}
          className={classes.popupBtnContainer}
        >
          <Grid item>
            <CustomButton label="Cancel" type="secondary" onClick={closePopup} />
          </Grid>
          <Grid item>
            <CustomButton label="Save" type="primary" onClick={handleSave} />
          </Grid>
        </Grid>
      </Grid>
      <ConfirmationDialog
        title="User Has RockED Insights Access"
        subText="This user currently has access to the RockED Insights dashboard. Since you are moving them to a different dealership, please choose whether to retain or remove their Insights access."
        onClose={onClickAddNewDealer}
        isOpen={showConfirmationDialog}
        confirmFn={() => onClickAddNewDealer(true)}
        disagreeText="No, Maintain Access"
        agreeText="Yes, Remove Access"
        Icon={AccessIcon}
        width="450px"
        height="260px"
        disableBackdropClick
      />
    </Modal>
  );
};
export default AddnewDepartmentPopup;
